/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const StyledButton = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: ${({ background }) => background};
  color: #fff;
  padding: 35px;
  height: 240px;
  width: 80%;
  margin: auto;

  /* @media (max-width: 1652px) {
    width: 300px;
  } */

  :hover {
    opacity: 0.6;
    transition: 0.5s;
  }

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;

    i {
      font-size: 40px;
    }
  }
`;

function CardButton({ href, color, onClick, children, ...props }) {
  return (
    <Link to={href} style={{ textDecoration: 'none', width: '100%' }}>
      <StyledButton color={color} onClick={onClick} {...props}>
        {children}
      </StyledButton>
    </Link>
  );
}

export default CardButton;
